export const VALUE_LABEL_DISPLAY_TYPES = {
  on: 'on',
  off: 'off',
};

export const SIZES = {
  medium: 'medium',
  small: 'small',
};
